import {FormGroup} from '@angular/forms';
import {CoreFormValidationHelper} from '@core/form/form-validation.helper';
import {HttpMethodsEnum} from '@core/http/methods.enum';

export abstract class CoreAppFormGroup<DataType = any> extends FormGroup {
    abstract getAll(): DataType;

    abstract getMode(): HttpMethodsEnum;

    validate(): this {
        CoreFormValidationHelper.validate(this);

        return this;
    }
}
